var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("quotes-send-modal", {
        ref: "quoteSendModal",
        on: { sent: _vm.refreshQuote }
      }),
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _vm.quote
            ? _c(
                "q-toolbar-title",
                [
                  _c("strong", [_vm._v(_vm._s(_vm.$tc("quote", 1)))]),
                  _vm._v(" #" + _vm._s(_vm.quote.quote_number) + "\n\n      "),
                  _c("status-chip", {
                    staticClass: "on-right",
                    attrs: {
                      small: "",
                      status: _vm.quote.status,
                      color: _vm.statusColor,
                      clickable: _vm.user.isUserOfActiveTeam(),
                      committed: _vm.isCommitted
                    },
                    on: {
                      cancel: _vm.handleCancel,
                      accepted: _vm.handleAccepted,
                      open: _vm.handleOpen
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("icon-bar", { attrs: { items: _vm.iconBarItems } })
        ],
        1
      ),
      _c("div", { staticClass: "layout-padding" }, [
        _vm.quote
          ? _c("div", { staticClass: "row gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col-12 col-lg-6 col-xl-7" },
                [_c("document-viewer", { attrs: { document: _vm.document } })],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-lg-6 col-xl-5" },
                [
                  _c(
                    "q-tabs",
                    {
                      attrs: { color: "tertiary", "underline-color": "white" }
                    },
                    [
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          label: _vm.$t("quote_meta"),
                          name: "meta",
                          default: ""
                        },
                        slot: "title"
                      }),
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          label: _vm.$tc("note", 2),
                          name: "notes"
                        },
                        slot: "title"
                      }),
                      _c(
                        "q-tab-pane",
                        { staticClass: "bg-white", attrs: { name: "meta" } },
                        [
                          _c(
                            "q-list",
                            { attrs: { "no-border": "" } },
                            [
                              _c(
                                "q-item",
                                { staticClass: "invoice__invoice-date-entry" },
                                [
                                  _c("q-item-main", {
                                    attrs: {
                                      label: _vm.quoteDate,
                                      sublabel: _vm.$t("quote_date")
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.validUntil
                                ? _c(
                                    "q-item",
                                    {
                                      staticClass: "invoice__invoice-date-entry"
                                    },
                                    [
                                      _c("q-item-main", {
                                        attrs: {
                                          label: _vm.validUntil,
                                          sublabel: _vm.$t("valid_until")
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.quote.invoices.data.length > 0
                                ? _c(
                                    "q-item",
                                    {
                                      staticClass: "invoice__invoice-date-entry"
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c(
                                            "q-item-tile",
                                            { attrs: { label: "" } },
                                            [
                                              _vm._l(
                                                _vm.quote.invoices.data,
                                                function(invoice) {
                                                  return [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        key: invoice.id,
                                                        staticClass:
                                                          "router-link",
                                                        attrs: {
                                                          to: {
                                                            name: "invoice",
                                                            params: {
                                                              teamId:
                                                                _vm.activeTeam
                                                                  .id,
                                                              invoice:
                                                                invoice.id
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              invoice.invoice_number
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                         \n                      "
                                                    )
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _c(
                                            "q-item-tile",
                                            { attrs: { sublabel: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$tc(
                                                    "invoice",
                                                    _vm.quote.invoices.data
                                                      .length
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "q-item",
                                { staticClass: "invoice__customer-name-entry" },
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm.quote.customer_exists
                                            ? _c(
                                                "router-link",
                                                {
                                                  staticClass: "router-link",
                                                  attrs: {
                                                    to: {
                                                      name: "customer",
                                                      params: {
                                                        customerId:
                                                          _vm.customer.id,
                                                        teamId:
                                                          _vm.activeTeam.id
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(_vm.customerName) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            : _c("div", [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(_vm.customerName) +
                                                    "\n                      "
                                                )
                                              ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "" } },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$tc("customer", 1)) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.contactPersonName
                                ? _c(
                                    "q-item",
                                    { staticClass: "invoice__due-date-entry" },
                                    [
                                      _c("q-item-main", {
                                        attrs: {
                                          label: _vm.contactPersonName,
                                          sublabel: _vm.$tc("contact_person", 1)
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.quote.address
                                ? _c(
                                    "q-item",
                                    {
                                      staticClass:
                                        "invoice__delivery-address-entry"
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c("q-item-tile", {
                                            attrs: { label: "" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.quote.address.data
                                                  .formatted_address
                                              )
                                            }
                                          }),
                                          _c(
                                            "q-item-tile",
                                            { attrs: { sublabel: "" } },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.$t("address")) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.createdBy
                                ? _c(
                                    "q-item",
                                    { staticClass: "invoice__due-date-entry" },
                                    [
                                      _c("q-item-main", {
                                        attrs: {
                                          label: [
                                            _vm.createdBy.first_name,
                                            _vm.createdBy.last_name
                                          ].join(" "),
                                          sublabel: _vm.$t("quote_created_by")
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.quote.project_id
                                ? _c(
                                    "q-item",
                                    { staticClass: "invoice__project-entry" },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c(
                                            "q-item-tile",
                                            { attrs: { label: "" } },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass: "router-link",
                                                  attrs: {
                                                    to: {
                                                      name: "project",
                                                      params: {
                                                        project:
                                                          _vm.quote.project_id,
                                                        teamId:
                                                          _vm.activeTeam.id
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.quote.project.data
                                                          .name
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-item-tile",
                                            { attrs: { sublabel: "" } },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$tc("project", 1)
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-tab-pane",
                        { staticClass: "bg-white", attrs: { name: "notes" } },
                        [
                          _c("note-input", {
                            staticStyle: { height: "250px" },
                            attrs: {
                              notes: _vm.notes,
                              createNoteMethod: _vm.handleCreateNote,
                              updateNoteMethod: _vm.handleUpdateNote,
                              deleteNoteMethod: _vm.handleDeleteNote,
                              hideEmptyState: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c("q-tab-pane", { attrs: { name: "tab-5" } }, [
                        _vm._v("Tab Five")
                      ])
                    ],
                    1
                  ),
                  _vm.activities
                    ? _c(
                        "q-card",
                        { staticClass: "bg-white q-mt-lg" },
                        [
                          _c(
                            "q-card-main",
                            [
                              _c("timeline", {
                                attrs: { activities: _vm.activities }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }